"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const headless_1 = __importDefault(require("@tippyjs/react/headless"));
const ARROW_WIDTH = '28px';
const ARROW_HEIGHT = '7px';
const Arrow = app_1.styled.svg `
  display: block;
  width: ${ARROW_WIDTH};
  height: ${ARROW_HEIGHT};
  fill: ${(theme) => theme.colors.gray.dark};
  > path {
    fill: ${(theme) => theme.colors.gray.dark};
    ${(theme) => theme.tooltip.arrow};
  }
  ${(theme) => theme.tooltip.arrow};
`;
const TooltipBox = app_1.styled.div `
  border-radius: 0.5rem;
  background: ${(theme) => theme.colors.gray.dark};
  box-shadow: 0px 0.375rem 0.75rem rgba(0, 0, 0, 0.2);
  border: 0.0625rem solid ${(theme) => theme.colors.gray.dark};
  padding: 0.75rem 1rem;
  color: white;
  font-size: 0.85rem;
  > .ArrowWrap {
    position: absolute;
  }

  &[data-placement^='bottom'] > .ArrowWrap {
    top: calc(1px - ${ARROW_HEIGHT});
  }
  &[data-placement^='right'] > .ArrowWrap {
    > svg {
      transform: rotate(-90deg);
    }
    left: calc(1px - ${ARROW_HEIGHT} - (${ARROW_WIDTH} - ${ARROW_HEIGHT}) / 2);
  }
  &[data-placement^='left'] > .ArrowWrap {
    > svg {
      transform: rotate(90deg);
    }
    right: calc(1px - ${ARROW_HEIGHT} - (${ARROW_WIDTH} - ${ARROW_HEIGHT}) / 2);
  }
  &[data-placement^='top'] > .ArrowWrap {
    > svg {
      transform: rotate(180deg);
    }
    bottom: calc(1px - ${ARROW_HEIGHT});
  }

  ${(theme) => theme.tooltip.css}
`;
function Tooltip(_a) {
    var { content, className } = _a, props = __rest(_a, ["content", "className"]);
    return ((0, jsx_runtime_1.jsx)(headless_1.default, Object.assign({ zIndex: 1000000001, render: (attrs) => ((0, jsx_runtime_1.jsxs)(TooltipBox, Object.assign({ className: className, tabIndex: -1 }, attrs, { children: [content, (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "ArrowWrap", "data-popper-arrow": "" }, { children: (0, jsx_runtime_1.jsx)(Arrow, Object.assign({ width: "28", height: "7", viewBox: "0 0 28 7", fill: "none" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "m 14,0.02812529 c -0.76775,0 -1.535594,0.2929063 -2.121094,0.87890631 L 9.0429688,3.742969 c -1.417,1.418 -2.0162188,2.0077812 -2.6992188,2.4257812 -0.627,0.384 -1.3084375,0.6668906 -2.0234375,0.8378906 -0.778,0.187 -1.6190469,0.1933594 -3.62304688,0.1933594 H 0 v 0 H 0.69726562 27.302734 28 27.302734 v 0 c 0,0 -2.845046,-0.00636 -3.623046,-0.1933594 -0.715,-0.171 -1.397438,-0.4538906 -2.023438,-0.8378906 -0.683,-0.418 -1.282219,-1.0077812 -2.699219,-2.4257812 L 16.121094,0.9070316 C 15.535594,0.32103159 14.76775,0.02812529 14,0.02812529 Z", fill: "currentcolor" }) })) }))] }))) }, props)));
}
exports.Tooltip = Tooltip;
